module.exports = __webpack_public_path__ + "img/main_logo.b1df766e.png";